﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import axios from 'axios'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import './styles/theme.css'   // 自定义主题（在 Element Plus 之后，覆盖默认样式）
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import router from './router'
import { getToken, clearAuth } from './utils/auth'

// 全局 dayjs 中文（影响所有 dayjs().format() 输出和日期选择）
dayjs.locale('zh-cn')

// ========== axios 全局拦截器：自动带 JWT + 401 自动跳登录 ==========
// 请求拦截：自动从 localStorage 读 token 放到 Authorization 头
axios.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// 响应拦截：401 表示 token 无效/过期，清掉并跳 /login
axios.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err && err.response && err.response.status
    if (status === 401) {
      // 排除 /auth/login 自身的 401（密码错时也返回 401）
      const url = (err.config && err.config.url) || ''
      if (!url.includes('/api/auth/login')) {
        clearAuth()
        // 用 location 而不是 router，避免被当前路由守卫卡住
        const here = window.location.hash.replace(/^#/, '') || '/'
        if (!here.startsWith('/login')) {
          window.location.hash = `#/login?redirect=${encodeURIComponent(here)}`
        }
      }
    }
    return Promise.reject(err)
  }
)

// 将 createApp(App) 的返回值赋给 app 变量
const app = createApp(App)
app.use(ElementPlus, { locale: zhCn })  // Element Plus 全局中文
app.use(router)
app.config.globalProperties.$axios = axios

const pinia = createPinia();
app.use(pinia);
app.mount('#app')
window.addEventListener('error', (event) => {
    if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
    }
  });
